import PeaksChart from './Peaks';
import React from 'react';
import VaccinationsChart from './Vaccinations';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const ChartsContainer = (props) => {
  const { vaccinations, country, nationalCounts } = props;
  return (
    <div className={classnames(component, 'clearfix')}>
      <div className='chart-container'>
        <h6>Percent of population vaccinated</h6>
        <VaccinationsChart country={country} vaccinations={vaccinations} />
      </div>
      <div className='section-spacer-internal' />
      <div className='chart-container'>
        <h6>Daily averages as % of peak</h6>
        {/* <p><small>Rolling 7-day average</small></p> */}
        <PeaksChart country={country} vaccinations={vaccinations} nationalCounts={nationalCounts} />
      </div>
    </div>
  );
};

export default ChartsContainer;
